var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('label',{staticClass:"form-label",class:{ required: _vm.required }},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.required)?_c('b',{staticClass:"ml-1 blue"},[_vm._v("*")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }